<template>
  <v-list
    density="comfortable"
    nav
    aria-label="L/C Tracking navigation"
  >
    <v-list-item
      to="/home/dashboard"
      aria-label="ERP Home"
    >
      <v-img
        :src="logo"
        alt="Remex"
        height="60"
        max-width="180"
        class="mx-auto"
      />
    </v-list-item>
    <v-list-item
      title="L/C Tracking"
      class="bg-primary text-center"
    />
    <v-list-item
      v-for="item in items"
      :key="item.view"
      :title="item.title"
      :prepend-icon="item.icon"
      :to="target(item.view)"
      :active="state.view === item.view || (item.view === 'cases' && state.view === 'case')"
      :disabled="state.busy || (item.view === 'new' && !state.permissions.insert)"
      @click.prevent="state.navigate?.(item.view)"
    >
      <template
        v-if="item.view === 'cases' && state.total !== null"
        #append
      >
        <v-chip size="x-small">{{ state.total }}</v-chip>
      </template>
    </v-list-item>
    <v-list-subheader>SOURCE MODULES</v-list-subheader>
    <v-list-item
      title="PI / Indent & L/C"
      prepend-icon="mdi-file-document-outline"
      :to="target('sources')"
      :active="state.view === 'sources'"
      :disabled="state.busy"
      @click.prevent="state.navigate?.('sources')"
    />
  </v-list>
</template>
<script setup>
// Loaded conditionally by layoutAdmin, matching the Customer Profile navigation integration.
import { computed } from 'vue';
import { useStore } from 'vuex';
import { fileServerUrl } from '@/store/api';
import fallbackLogo from '@/assets/image/logo.png';
import { trackingNavigation as state } from './navigationState';
const store = useStore();
const logo = computed(() =>
  store.getters.getCurrentCompany?.logo_thumb
    ? fileServerUrl + store.getters.getCurrentCompany.logo_thumb
    : fallbackLogo,
);
const target = (view) => ({ name: 'lc-tracking-' + view });
const items = [
  { view: 'dashboard', title: 'Dashboard', icon: 'mdi-view-dashboard-outline' },
  { view: 'cases', title: 'Tracking Cases', icon: 'mdi-ferry' },
  { view: 'new', title: 'New Tracking Case', icon: 'mdi-plus' },
  { view: 'links', title: 'Customer Links', icon: 'mdi-link-variant' },
  { view: 'reports', title: 'Reports', icon: 'mdi-chart-bar' },
];
</script>
